// React
import React from "react";
// Component (lib)
import {
  Board,
  CqlMeasureConfiguration,
  Multiboard,
  Slot,
} from "@fyrstain/fhir-front-library";

import BoardService from "../features/services/boardService";

type Props = {
  librarySource: string;
  periodStart: string;
  periodEnd: string;
  defaultCqlConfiguration?: CqlMeasureConfiguration;
  onError?: (error?: unknown) => void;
};

const makeDefaultSlots = (): Slot[] =>
  Array.from({ length: 6 }, (_, i) => ({
    slotId: `slot-${i}`,
    measureId: undefined,
    measureTitle: undefined,
    displayType: undefined,
    selectedStratifierId: undefined,
    percentageBase: undefined,
  })) as Slot[];

const mergeCqlConfiguration = (
  defaults?: CqlMeasureConfiguration,
  saved?: CqlMeasureConfiguration,
): CqlMeasureConfiguration | undefined => {
  const merged = { ...defaults, ...saved };
  const configuredEntries = Object.entries(merged).filter(
    ([, value]) => value !== undefined && value !== "",
  );

  return configuredEntries.length > 0
    ? (Object.fromEntries(configuredEntries) as CqlMeasureConfiguration)
    : undefined;
};

export default function MultiboardContainer2({
  librarySource,
  periodStart,
  periodEnd,
  defaultCqlConfiguration,
  onError,
}: Props) {

  const [state, setState] = React.useState<Board[]>([]);
  const [counter, forceUpdate] = React.useReducer(x => x + 1, 0);

  React.useEffect(() => {
    BoardService.getAllBoard()
      .then((boards) => {
        if (boards.length === 0) {
          setState([
            {
              id: "12346",
              name: "Statistiques",
              slots: makeDefaultSlots(),
              cqlConfiguration: mergeCqlConfiguration(defaultCqlConfiguration),
            }
          ])
        } else {
          setState(
          boards.map((board: Board) => ({
            ...board,
            cqlConfiguration: mergeCqlConfiguration(
              defaultCqlConfiguration,
              board.cqlConfiguration,
            ),
            slots:
              Array.isArray(board.slots) && board.slots.length > 0
                ? board.slots.map((slot: any, index: number) => ({
                ...slot,
                slotId: String(slot?.slotId ?? `slot-${index}`),
                measureId: slot?.measureId,
                measureTitle: slot?.measureTitle,
                displayType: slot?.displayType,
                selectedStratifierId: slot?.selectedStratifierId,
                percentageBase: slot?.percentageBase,
                }))
              : makeDefaultSlots(),
            }))
          );
        }
      })
      .catch(onError);
  }, [counter, defaultCqlConfiguration, onError]);

  return (
    <Multiboard
      librarySource={librarySource}
      periodStart={periodStart}
      periodEnd={periodEnd}
      boards={state}
      saveBoard={(board: Board) => {
          BoardService.saveBoard(board).finally(() => forceUpdate());
        }}
      deleteBoard={(id: string) => {
          BoardService.deleteBoard(id).finally(() => forceUpdate())
        }
      }
      onError={onError}
    />
  );
}
